import React from 'react'
import ChartPie from './ChartPie'

export * from './ChartPie'

export default React.memo(ChartPie)
